import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    SITE_TELEMETRY_ADDRESS_AUTOFILL?: boolean;
    ACTIVE_RESPONSE_GENERIC_FIREWALL_EDL?: boolean;
    ACTIVE_RESPONSE_TEST_ENV?: boolean;
    ACTIVE_RESPONSE_TANIUM?: boolean;
  }
}

export default {
  featureFlags: {
    // AWN-218319 Address Autofill Input -- Site Telemetry
    SITE_TELEMETRY_ADDRESS_AUTOFILL: true,
    ACTIVE_RESPONSE_GENERIC_FIREWALL_EDL: undefined,
    ACTIVE_RESPONSE_TEST_ENV: undefined,
    ACTIVE_RESPONSE_TANIUM: undefined,
  },
} satisfies FeatureFlagConfig;
